import './SearchResultView.css';

import React, { FC } from 'react';

import SubTabs from 'js/shared/components/SubTabs';
import { ReactComponent as IconLeftMinimise } from 'imgs/svg-icons/IconLeftMinimise.svg';
import { ImageCategory } from 'js/types';
import { SearchType } from 'js/reducers/imageSearchReducer';

import ImageLibraryFilters from '../ImageLibraryFilters';
import SelectedCharacterPanel from '../SelectedCharacterPanel';

import useSubTabs from './hooks/useSubTabs';

type SearchResultViewProps = {
  onClickToCategories: () => void;
  onClickToCharacters: () => void;
  isCharacterMode?: boolean;
  searchType: SearchType;
  searchInput: string;
  categoryId: string | null;
  onCategoryClick: (category: ImageCategory) => void;
  hideBackToCategories?: boolean;
};

const SearchResultView: FC<SearchResultViewProps> = ({
  onClickToCategories,
  onClickToCharacters,
  isCharacterMode = false,
  searchType,
  searchInput,
  categoryId,
  onCategoryClick,
  hideBackToCategories = false
}) => {
  const { handleTabChange, configTabs, selectedTab } = useSubTabs(searchType, searchInput, categoryId, onCategoryClick);

  return (
    <div className="SearchResultView">
      <div className="SearchResultView__navigation">
        {isCharacterMode && (
          <button className="SearchResultView__navigation-btn" type="button" onClick={onClickToCharacters}>
            <IconLeftMinimise />
            back to Characters
          </button>
        )}
        {!hideBackToCategories && !isCharacterMode && (
          <button className="SearchResultView__navigation-btn" type="button" onClick={onClickToCategories}>
            <IconLeftMinimise />
            back to All Categories
          </button>
        )}

        {selectedTab === 'videoscribe' && !categoryId && <ImageLibraryFilters />}
      </div>

      {isCharacterMode && <SelectedCharacterPanel />}

      <SubTabs tabs={configTabs()} activeTab={selectedTab} onTabChange={handleTabChange} />
    </div>
  );
};

export default SearchResultView;
